import accordionBaseValidator from './accordion';

export default accordionBaseValidator;
